import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  GetUserWalletByUserId,
  PaidWallet,
  ReframeEndDateTimeFormat,
} from "../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import dayjs from "dayjs";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import {
  DeleteIcon,
  SearchIcon,
  CloudOffIcon,
  LockPersonIcon,
} from "../../Resources/Icons/icons";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { visuallyHidden } from "@mui/utils";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";
import Button from "@mui/material/Button";
import * as Yup from "yup";
import ButtonGroup from "@mui/material/ButtonGroup";
import Drawer from "@mui/material/Drawer";
import PaidTransaction from "./PaidTransaction";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import { CSVLink } from "react-csv";
import { GetPolicyFileById } from "../../Service/_index";
import Loader from "../../UiComponents/Loader/Loader";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import { checkUserType } from "../../Shared/CommonConstant";
import SmartRangePicker from "../../UiComponents/SmartRangePicker/SmartRangePicker";
import { Transition } from "../../UiComponents/Transition/Transition";
import Dialog from "@mui/material/Dialog";
import WalletPassword from "./WalletPassword";
import filterr from "../../Resources/Images/filter-lines.png";
import exportt from "../../Resources/Images/export.png";
import { Badge, Divider, Modal, Stack } from "@mui/material";
import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
import CustomButton from "../../UiComponents/CommonBUtton/ConfirmBox";
import FilterBox from "../../UiComponents/FilterBox/FilterBox";
import wallett from "../../Resources/Images/wallet.png";
import user from "../../Resources/Images/user.png";


function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getClassName = (data) => {
  console.log("data", data);
  return data.policyNumber ? "file_link" : null;
};

const headCells = [
  {
    id: "approvedDate",
    placeMent: true,
    disablePadding: false,
    label: "Approve Date",
    type: "component",
    renderComponent: (row) => (
      <Typography
        sx={{
          fontSize: "14px",
          fontFamily: "Inter",
          color: "#667085",
          fontWeight: 500,
        }}
      >
        {row.approvedDate
          ? moment(row.approvedDate).format("DD-MM-YYYY HH:mm:ss")
          : "--"}
      </Typography>
    ),
  },
  {
    id: "policyDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
    type: "date",
  },
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
    class: getClassName,
    onClick: true,
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "paymentMode",
    placeMent: true,
    disablePadding: false,
    label: "Payment Mode",
  },
  {
    id: "netPremium",
    placeMent: true,
    disablePadding: false,
    label: "Net Premium",
  },
  {
    id: "totalPremium",
    placeMent: true,
    disablePadding: false,
    label: "Total Premium",
  },
  {
    id: "payableAmount",
    placeMent: true,
    disablePadding: false,
    label: "Payable Amount",
  },
  {
    id: "policyBalance",
    placeMent: true,
    disablePadding: false,
    label: "Policy Balance",
  },
  {
    id: "walletBalance",
    placeMent: true,
    disablePadding: false,
    label: "Wallet Balance",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
            style={{ minWidth: headCells.minWidth }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  // rowCount: PropTypes.number.isRequired,
};

const ManageWallet = (props) => {
  const {
    selectedData,
    formType,
    setOpenDrawer,
    GetData,
    startDate,
    endDate,
    totalWallet,
    calculateSum,
  } = props;
  let formRef = useRef();
  const [openLoader, setOpenLoader] = useState(false);
  console.log("selectedData", selectedData);

  // console.log("selectedData ", selectedData);

  const [walletAmt, setWalletAmt] = React.useState(selectedData.walletBalance); // Changes by Arun
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [data, setData] = useState([]);
  const [openPaidTransaction, setOpenPaidTransaction] = useState();
  const [functionType, setFunctionType] = useState();
  const [originalData, setOriginalData] = useState([]);
  let currentDate = new Date();
  let last7Days = new Date();
  last7Days.setDate(last7Days.getDate() - 7);

  const [dateRange, setDateRange] = useState([
    startDate ? dayjs(startDate) : dayjs(last7Days),
    endDate ? dayjs(endDate) : dayjs(currentDate),
  ]);
  const [openWalletPwdDrawer, setOpenWalletPwdDrawer] = React.useState(false); //Changes by Arun
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [value, setValue] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [tableConfig, setTableConfig] = useState({
    isSearch: true,
    isApprove: true,
  });
  // Changes by Arun
  const [displayResetPassword, setDisplayResetPassword] = useState(
    selectedData.walletPassword ? true : false,
  );

  // set default states
  const [selectedStartDate, setSelectedStartDate] = useState(
    startDate ? dayjs(startDate) : dayjs(last7Days),
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    endDate ? dayjs(endDate) : dayjs(currentDate),
  );
  // console.log("selectedStartDate ", selectedStartDate);
  // console.log("selectedEndDate ", selectedEndDate);

  const [drawerWidth, setDrawerWidth] = useState("25%");
  const [isAllow, setIsAllow] = useState({}); //Changes by Arun

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter?.fn(data), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, filter, data],
  );
  console.log("visibleRows", visibleRows);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const activeFiltersCount = (() => {
    let c = 0;
    // if (filterType) c += 1;
    // if (selectedUser) c += 1;
    if (selectedStartDate && selectedEndDate) c += 1;
    return c;
  })();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // useEffect(() => {
  //   setSelectedStartDate(dayjs(last7Days));
  //   setSelectedEndDate(dayjs(currentDate));
  // }, []);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;
  const UserId = sessionStorage.getItem("UserId");

  const GetUserWalletDetails = async () => {
    setOpenLoader(true);

    let customEndDate = null;
    let customStartDate = null;

    if (selectedStartDate) {
      customStartDate = dayjs(dateRange[0]).format("YYYY-MM-DD");
    }

    if (selectedEndDate) {
      customEndDate = await ReframeEndDateTimeFormat(dateRange[1]);
    }

    GetUserWalletByUserId(selectedData?.userId, {
      selectedStartDate: customStartDate,
      customEndDate,
    })
      .then((res) => {
        console.log("Res:", res?.data);
        const walletData = res?.data || [];
        setData(walletData);
        setOriginalData(walletData);
        setWalletAmt(
          walletData.length ? walletData[0]?.walletBalance : walletAmt,
        );
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const UserType = sessionStorage.getItem("userType");
  useEffect(() => {
    const isallowObj = checkUserType(UserType);
    setIsAllow(isallowObj);
  }, [selectedData, selectedStartDate, selectedEndDate]);

  useEffect(() => {
    if (startDate && endDate) {
      const start = dayjs(startDate);
      const end = dayjs(endDate);
      setSelectedStartDate(start);
      setSelectedEndDate(end);
      setDateRange([start, end]);
    }
  }, [startDate, endDate]);

  const PaidUserName = visibleRows?.[0]?.userName;

  const PaidFunction = () => {
    setOpenPaidTransaction(true);
    setFunctionType("Paid");
  };

  const ReceivedFunction = () => {
    setOpenPaidTransaction(true);
    setFunctionType("Received");
  };

  const handleBack = () => {
    setOpenDrawer(false);
  };

  const onSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    if (searchTerm === "") {
      setData(originalData);
    } else {
      const filteredData = originalData.filter((item) => {
        return Object.values(item).some(
          (value) =>
            value && value.toString().toLowerCase().includes(searchTerm),
        );
      });
      setData(filteredData);
    }
    setPage(0);
  };

  // Changes by Arun
  const walletPasswordAction = () => {
    setOpenWalletPwdDrawer(true);
  };

  // Changes by Arun
  const closeDialog = () => {
    setOpenWalletPwdDrawer(false);
  };

  // Changes by Arun
  const closeDrawer = () => {
    setOpenDrawer(false);
    if (isAllow.isUser) {
      GetData();
    }
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?.policyId)
      .then((res) => {
        const pdfUrl = res?.data.policyFile.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        // setOpenLoader(false);
        // Changes by Arun
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`,
        );
        // const pdfWindow = window.open("", "_blank");
        // pdfWindow?.document?.write(
        //   `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
        // );
      })
      .catch((err) => {
        ToastError("Something went wrong");
        setOpenLoader(false);
      });
  };
  const header = [
    { label: "Approve Date", key: "approvedDate" },
    { label: "Policy Date", key: "policyDate" },
    { label: "Company Name", key: "companyName" },
    { label: "Policy Number", key: "policyNumber" },
    { label: "Customer Name", key: "customerName" },
    { label: "Payment Mode", key: "paymentMode" },
    { label: "Payable Amount", key: "payableAmount" },
    { label: "Total Premium", key: "totalPremium" },
    { label: "Net Premium", key: "netPremium" },
    { label: "Policy Balance", key: "policyBalance" },
    { label: "Wallet Balance", key: "walletBalance" },
  ];
  const csvFile = {
    filename: "User Manage Wallet",
    headers: header,
    data: data,
  };

  const setDateRangeee = (date) => {
    console.log("Selected Date:", date);
    // setDate(date);
  };

  const handleClearAllState = () => {
    setDateRange([dayjs(last7Days), dayjs(currentDate)]);
  };

  const handleSaveAllFilter = () => {
    GetUserWalletDetails();
  };

  const handleFiltersClick = () => {
    setFiltersVisible((prev) => !prev);
  };

  const safeSetDateRange = (value) => {
    if (!value || value.length !== 2) {
      setDateRange([dayjs(last7Days), dayjs(currentDate)]);
    } else {
      setDateRange(value);
    }
  };

  const filterBoxData = [
    {
      id: 1,
      label: "Select Date",
      setDate: safeSetDateRange,
      type: "noDefaultDate",
      defaultValue: [
        startDate ? dayjs(startDate) : dayjs(last7Days),
        endDate ? dayjs(endDate) : dayjs(currentDate),
      ],
    },
  ];

  const getRandomNumberUsingTimestamp = () => {
    const timestamp = new Date().getTime();
    return timestamp;
  };

  const handleSubmit = async (e) => {
    e.isUserPayable = true;
    const RandomNumber = await getRandomNumberUsingTimestamp();
    e.userId = selectedData.userId;
    e.policyNumber = RandomNumber.toString();
    e.paymentMode = functionType === "Paid" ? "PAID" : "RECEIVED";
    e.createdBy = UserId;
    e.withTDS = value == 0 ? true : false;
    PaidWallet(e)
      .then((res) => {
        GetData();
        GetUserWalletDetails();
        setOpenPaidTransaction(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      {/* <Grid container className="DrawerHeader" mt={6}>
          <Grid item xs={6} sm={6}>
          </Grid>
          <Grid item xs={6} sm={6} className="d-flex justify-content-end">
            <CloseIcon
              onClick={() => closeDrawer()}
              sx={{ cursor: "pointer" }}
            />
          </Grid>
        </Grid> */}

      {/* Changes by Arun */}
      <div style={{ padding: 10 }}>
        <Grid
          container
          spacing={2}
          sx={{ padding: "10px 10px 0 10px" }}
          className="Master_Header_Container"
        >
          <Grid item sm={3} xs={12}>
            <FloatLabel label="Start date & End Date" value="react">
              <SmartRangePicker
                placement="bottomLeft"
                className="textField w-100"
                style={{ borderRadius: "0px" }}
                value={
                  selectedStartDate && selectedEndDate
                    ? [dayjs(selectedStartDate), dayjs(selectedEndDate)]
                    : null
                }
                onChange={(dates) => {
                  if (dates) {
                    const start = dayjs(dates[0]);
                    const end = dayjs(dates[1]);
                    setSelectedStartDate(start);
                    setSelectedEndDate(end);
                    setDateRange([start, end]);
                  } else {
                    setSelectedStartDate(null);
                    setSelectedEndDate(null);
                    setDateRange([null, null]);
                  }
                }}
                format="DD/MM/YYYY"
              />
            </FloatLabel>
          </Grid>

          <Grid
            item
            sm={2}
            xs={12}
            sx={{ display: "flex", marginBottom: "8px" }}
            gap={2}
          >
            <Button
              className="Master_Header_create_Button"
              sx={{ width: { xs: "100%", sm: "75%" } }}
              onClick={GetUserWalletDetails}
            >
              Search
            </Button>
          </Grid>
          <Grid
            item
            sm={3}
            xs={12}
            sx={{ display: isAllow.isUser ? "block" : "none" }}
          />
        </Grid>
        <Grid container mt={2} sx={{ justifyContent: "flex-end" }}>
          {/* <CloseIcon
            onClick={() => setOpenDrawer(false)}
            sx={{ cursor: "pointer" }}
          /> */}
        </Grid>
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            margin: 0,
            padding: 0,
            boxSizing: "border-box",
          }}
        >
          <Grid
            container
            // sx={{
            //   width: "100% !important",
            //   margin: "0 !important",
            //   maxWidth: "100% !important",
            //   padding: "0 !important",
            //   backgroundColor: "#ffffff !important",
            //   borderRadius: "6px !important",
            //   border: "1px solid #eaecf0",
            //   boxSizing: "border-box !important",
            // }}
            className="Master_Card_Container"
          >
            <Grid
              container
              alignItems="center"
              className="Master_Card_Sub_Container"
              spacing={2}
              // sx={{
              //   padding: "10px 10px 10px 10px !important",
              //   width: "100% !important",
              //   margin: "0 !important",
              //   boxSizing: "border-box !important",
              // }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                sx={{ display: "flex", gap: "7px" }}
              >
                <Typography className="Master_Card_Tittle">
                  Manage Wallet
                </Typography>
                <img src={user} width="22px" height="22px" />
                <Typography sx={{ color: "#667085" }}>
                  {visibleRows?.[0]?.userName}
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                className="d-flex justify-content-end"
                gap={"8px"}
              >
                {/* <CustomButton
                  text="Filter"
                  fontSize="12px"
                  height="35px"
                  width="fit-content"
                  color="#fff"
                  icon={FilterListIcon}
                  onClick={handleFiltersClick}
                /> */}
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ alignItems: "center" }}
                >
                  <Button
                    className="Master_Card_Filter_Button"
                    sx={{ width: "102px", height: "40px", gap: "8px" }}
                    startIcon={
                      <Badge
                        badgeContent={activeFiltersCount}
                        sx={{
                          "& .MuiBadge-badge": {
                            right: 5,
                            top: 3,
                            width: "14px",
                            height: "14px",
                            minWidth: "14px",
                            borderRadius: "50%",
                            fontSize: "8.91px",
                            fontWeight: "600",
                            backgroundColor: "#E50000",
                            color: "#fff",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          },
                        }}
                      >
                        <FilterListIcon sx={{ marginRight: "1.5px" }} />
                      </Badge>
                    }
                    onClick={() => setShowFilter((s) => !s)}
                    size="small"
                    variant="outlined"
                  >
                    Filter
                  </Button>
                  <Button
                    className="export_button"
                    sx={{
                      border: "1px solid #d0d5dd",
                      backgroundColor: "transparent",
                      borderRadius: "8px",
                      textTransform: "none",
                      color: "#344054",
                      fontWeight: 500,
                      fontSize: "13px",
                      width: "fit-content",
                    }}
                    startIcon={
                      <CloudDownloadOutlinedIcon
                        sx={{
                          color: "#344054",
                        }}
                      />
                    }
                  >
                    <CSVLink
                      style={{ textDecoration: "none", color: "#344054" }}
                      {...csvFile}
                    >
                      <p style={{ margin: 0, padding: 0, fontFamily: "inter" }}>
                        Export
                      </p>
                    </CSVLink>
                  </Button>

                  <Button
                    className="Master_Card_create_Button"
                    onClick={PaidFunction}
                    sx={{
                      height: "35px",
                      backgroundColor: "#1E3A5F",
                      color: "white",
                      fontSize: "12px",
                      fontFamily: "inter",
                      textTransform: "capitalize",
                      borderRadius: "8px",
                      padding: "0px 14px",
                      width: "fit-content",
                      "&:hover": {
                        backgroundColor: "#0060dd",
                      },
                      display: isAllow.isUser ? "none" : "block",
                    }}
                  >
                    Paid
                  </Button>
                  <Button
                    className="Master_Card_create_Button"
                    onClick={ReceivedFunction}
                    sx={{
                      height: "35px",
                      backgroundColor: "#1E3A5F",
                      color: "white",
                      fontSize: "12px",
                      fontFamily: "inter",
                      textTransform: "capitalize",
                      borderRadius: "8px",
                      padding: "0px 14px",
                      width: "fit-content",
                      "&:hover": {
                        backgroundColor: "#0060dd",
                      },
                      display: isAllow.isUser ? "none" : "block",
                    }}
                  >
                    Received
                  </Button>
                  {/* Changes by Arun */}
                  <Button
                    className="Master_Card_create_Button"
                    sx={{
                      height: "35px",
                      backgroundColor: "#1E3A5F",
                      color: "white",
                      fontSize: "12px",
                      fontFamily: "inter",
                      textTransform: "capitalize",
                      borderRadius: "8px",
                      padding: "0px 14px",
                      width: "fit-content",
                      "&:hover": {
                        backgroundColor: "#0060dd",
                      },
                      display:
                        isAllow.isUser && displayResetPassword
                          ? "block"
                          : "none",
                    }}
                    onClick={walletPasswordAction}
                    // startIcon={<LockPersonIcon />}
                  >
                    Reset Wallet Password
                  </Button>
                  <Button
                    sx={{
                      height: "35px",
                      backgroundColor: "#F2F4F7",
                      color: "#344054",
                      fontSize: "12px",
                      fontFamily: "inter",
                      textTransform: "capitalize",
                      borderRadius: "8px",
                      padding: "0px 14px",
                      width: "fit-content",
                      border: "1px solid #D0D5DD",
                      "&:hover": {
                        backgroundColor: "#E4E7EC",
                      },
                    }}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                </Stack>
              </Grid>
            </Grid>

            {showFilter && (
              <Box
                sx={{
                  mb: 2,
                  overflow: "visible",
                  position: "relative",
                  zIndex: 1200,
                  minHeight: "60px",
                  width: "100%",
                }}
              >
                <FilterBox
                  filterData={filterBoxData}
                  type={"single"}
                  handleClearAllState={handleClearAllState}
                  handleSaveAllFilter={handleSaveAllFilter}
                  // handleClearSingleFilter={handleClearSingleFilter}
                  horizontalLayout={true}
                  hideHeader={true}
                  hideInput={true}
                  alwaysOpen={true}
                  autoApply={false}
                  hideDefaultButtons={false}
                />
              </Box>
            )}

            <Grid item xs={12}>
              <Divider
                sx={{
                  backgroundColor: "#EAECF0",
                  borderWidth: 1,
                  marginTop: 1,
                  marginBottom: 1,
                }}
              />
            </Grid>
            <Grid
              container
              mb={1}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid
                item
                marginLeft={1}
                marginTop={0}
                marginBottom={0}
                sx={{
                  backgroundColor: "#F0F5FA",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  padding: "2px",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                  gap: "10px",
                  border: "1px solid #DFE7F1",
                }}
              >
                <Grid>
                  <img src={wallett} width="18px" height="17px" />
                </Grid>
                <Grid>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: "500",
                      color: "#1E3A5F",
                      fontSize: 16,
                      lineHeight: "1.2",
                    }}
                  >
                    ₹ {walletAmt || 0}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: "500",
                      color: "#667085",
                      fontSize: 12,
                      lineHeight: "1.2",
                    }}
                  >
                    Total Manage Wallet
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
                md={3.1}
                marginRight={1}
                marginTop={0}
                marginBottom={0}
              >
                <Input
                  focused="false"
                  className="w-100 Master_Card_Input"
                  id="standard-adornment-password"
                  onChange={(e) => {
                    onSearch(e);
                    setPage(0);
                  }}
                  disableUnderline={true}
                  placeholder="Search in Manage Wallet"
                  sx={{
                    borderRadius: "8px",
                    height: "31px !important",
                    backgroundColor: "#f6f8f9",
                    fontSize: "12px",
                    fontWeight: 500,
                    fontFamily: "inter",
                    padding: "0 10px",
                  }}
                  startAdornment={
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "0px" }}
                    >
                      <IconButton aria-label="toggle password visibility">
                        <SearchIcon
                          sx={{
                            fontSize: "20px",
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Grid>
            </Grid>
            <MasterCommonTable
              tableConfig={tableConfig}
              data={data}
              columns={headCells}
              handleOnClickBehaviour={OpenPolicyFile}
              loading={openLoader}
              // isServerSide={true}
              // handleEdit={EditCompanyData}
              // handleView={ViewCompanyData}
              // handleDelete={DeleteCompanyData}
              // handleApprove={ActiveCompanyData}
              // tableTotalCount={filter.fn(company)?.length || 0}
              // tableOutputEvent={tableOutputEvent}
            />
          </Grid>
          {/* {filtersVisible && ( */}
          <FilterBox
            filterData={filterBoxData}
            // type={"single"}
            handleClearAllState={handleClearAllState}
            handleSaveAllFilter={handleSaveAllFilter}
          />
          {/* )} */}
        </div>
      </div>
      <Modal
        open={openPaidTransaction}
        onClose={() => setOpenPaidTransaction(false)}
        aria-labelledby="paid-transaction-modal"
        aria-describedby="paid-transaction-details"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: 600, md: 700 },
            height: "auto",
            maxHeight: "80vh",
            bgcolor: "background.paper",
          }}
        >
          <PaidTransaction
            setOpenPaidTransaction={setOpenPaidTransaction}
            selectedData={selectedData}
            PaidUserName={PaidUserName}
            GetUserWalletDetails={GetUserWalletDetails}
            functionType={functionType}
            GetData={GetData}
            setDrawerWidth={setDrawerWidth}
            onSubmit={handleSubmit}
            formRef={formRef}
            setValue={setValue}
            value={value}
          />
        </Box>
      </Modal>

      <Dialog
        open={openWalletPwdDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            maxWidth: "30%",
          },
        }}
      >
        {openWalletPwdDrawer ? (
          <WalletPassword
            setOpenDrawer={setOpenWalletPwdDrawer}
            setDisplayResetPassword={setDisplayResetPassword}
            formType={"edit"}
            title={"Reset"}
            closeDialog={closeDialog}
          />
        ) : null}
      </Dialog>
      {/* <Loader open={openLoader} /> */}
    </>
  );
};

export default ManageWallet;
